export const endpoints = {
	'sublease-request': (id) => `request/sublease-request/${id}`,
	'swap-request': `request/swap-request`,
	'mark-request-status': (id) => `request/requests/${id}`,
	find: 'propertyInfo/find/',
	'user-properties': (id) => `propertyInfo/user/${id}`,
	'create-subscription': 'stripe/create-subscription',
	'cancel-subscription': 'stripe/cancel-subscription',
	'change-default-payment-method': 'stripe/change-default-payment-method',
	'confirm-transaction': 'stripe/confirm-transaction',
	'user-requests': (id) => `users/requests/${id}`,
	'generate-otp': 'users/generate-otp',
	'create-coupon': 'users/create-coupon',
	'send-email': 'users/send-email',
	'add-review': 'review/add-review',
	'update-property': (id) => `propertyInfo/updateProperty/${id}`,
	'delete-property': (id) => `propertyInfo/${id}`,
	'find-by-ids': 'users/findByIds',
	findLocation: 'propertyInfo/findAll/location',
	findReview: 'review/find-review',
}
